import { action } from 'typesafe-actions';
import { CERTIFICATES_TYPES, Certificates } from './types';

export const getCertificatesAction = (payload?: any, stores?: any) =>
  action(CERTIFICATES_TYPES.GET_CERTIFICATES_REQUEST, { payload, stores });

export const setCertificatesAction = (data: Certificates) =>
  action(CERTIFICATES_TYPES.SET_DATA_CERTIFICATES, data);

export const setError = (error: any) =>
  action(CERTIFICATES_TYPES.SET_ERROR, error);
